import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { CourseOfferingApi } from '../api/CourseOfferingApi';
import { UserAdminApi } from "../api/UserAdminApi";
import { IUser } from '../api/UserApi';
import AppBarContext from '../context/AppBarContext';
import { handleErrorMessage } from './ErrorDialog';

interface CourseStudentRosterProps {
    courseOfferingId: number;
    courseId: number;
}

const CourseStudentRoster: React.FC<CourseStudentRosterProps> = ({ courseOfferingId }) => {

    const { setErrorMessage } = React.useContext(AppBarContext)
    const history = useHistory();
    const location = useLocation();

    const [userRoster, setUserRoster] = React.useState<IUser[]>([]);
    // const [summaryRoster, setSummaryRoster] = React.useState<UserDialogPromptUserSummary[][]>([]);
    // const [userActivitySecRoster, setUserActivitySecRoster] = React.useState<IUserActivitySummary[]>([]);
    // const [userCourseSummaryRoster, setUserCourseSummaryRoster] = React.useState<[number, number][]>([]);

    const [openDeleteUserDialog, setOpenDeleteUserDialog] = React.useState(false);
    const [deleteUserCourseOffering, setDeleteUserCourseOffering] = React.useState<IUser | null>(null);

    const [searchFirstName, setSearchFirstName] = React.useState<string | undefined>(undefined);
    const [searchLastName, setSearchLastName] = React.useState<string | undefined>(undefined);
    const [searchEmail, setSearchEmail] = React.useState<string | undefined>(undefined);
    const [searchUserList, setSearchUserList] = React.useState<IUser[]>([]);

    const fetchRoster = React.useCallback(async () => {
        try {
            CourseOfferingApi.studentRoster(courseOfferingId).then((response) => {
                setUserRoster(response.data);
                // setSummaryRoster(response.data[1]);
                // setUserActivitySecRoster(response.data[2])
            });
        } catch (err: any) {
            handleErrorMessage(err, setErrorMessage, history, location);
        }
    }, [courseOfferingId, setUserRoster, setErrorMessage, history, location]);
    React.useEffect(() => {
        fetchRoster();
    }, [fetchRoster]);

    const handleOpenDeleteUserDialog = (user: IUser) => {
        setDeleteUserCourseOffering(user);
        setOpenDeleteUserDialog(true);
    };

    const handleCloseDeleteUserDialog = () => {
        setOpenDeleteUserDialog(false);
    };

    const confirmDeleteUser = async () => {
        if (deleteUserCourseOffering !== null && deleteUserCourseOffering.email != undefined) {
            await handleDeleteUser(deleteUserCourseOffering.email);
            handleCloseDeleteUserDialog(); // Close the dialog after deletion
        }
    };

    const handleDeleteUser = async (email: string) => {
        CourseOfferingApi.drop(courseOfferingId, email)
            .then((response) => {
                if (response.status < 300) {
                    return response.data;
                }
                console.error(response);
                handleErrorMessage(response, setErrorMessage, history, location);
                return [];
            })
            .then(() => {
                CourseOfferingApi.studentRoster(courseOfferingId).then((response) => {
                    setUserRoster(response.data);
                    // setSummaryRoster(response.data[1]);
                    // setUserActivitySecRoster(response.data[2]);
                });
            })
            .catch((err) => {
                if (err.response.status == 492) {
                    setErrorMessage("This user is read only and cannot delete.");
                } else {
                    handleErrorMessage(err, setErrorMessage, history, location);
                }
            });
    };

    const handleSearchFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchFirstName(e.target.value);
    };

    const handleSearchLastNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchLastName(e.target.value);
    };

    const handleSearchEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchEmail(e.target.value);
    };

    const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        UserAdminApi.search(searchFirstName, searchLastName, searchEmail)
            .then((response) => {
                if (response.status < 300) {
                    return response.data;
                }
                console.error(response);
                handleErrorMessage(response, setErrorMessage, history, location);
                return [];
            })
            .then((userList) => {
                setSearchUserList(userList)
            })
            .catch((err) => {
                if (err.response.status == 492) {
                    setErrorMessage("This user is read only and cannot delete.");
                } else {
                    handleErrorMessage(err, setErrorMessage, history, location);
                }
            });
    };

    const handleSearchEnroll = (user: IUser) => {
        if (user.email) {
            CourseOfferingApi.enroll(courseOfferingId, user.email)
                .then((response) => {
                    if (response.status < 300) {
                        return response.data;
                    }
                    console.error(response);
                    handleErrorMessage(response, setErrorMessage, history, location);
                    return [];
                })
                .then(() => {
                    CourseOfferingApi.studentRoster(courseOfferingId).then((response) => {
                        setUserRoster(response.data);
                        // setSummaryRoster(response.data[1]);
                        // setUserActivitySecRoster(response.data[2]);
                    });
                })
                .catch((err) => {
                    if (err.response.status == 492) {
                        setErrorMessage("This user is read only and cannot delete.");
                    } else {
                        handleErrorMessage(err, setErrorMessage, history, location);
                    }
                });
        }
    }

    // React.useEffect(() => {
    //     const courseSummaryList: [number, number][] = [];
    //     for (const summaryList of summaryRoster) {
    //         const courseCount: [number, number] = [0, 0];

    //         summaryList.forEach((item) => {
    //             const { course_id, lesson_id, dialog_id, dialog_prompt_count, user_dialog_prompt_count } = item;

    //             if (course_id == courseId) {
    //                 courseCount[0] += dialog_prompt_count;
    //                 courseCount[1] += user_dialog_prompt_count;
    //             }
    //         });
    //         courseSummaryList.push(courseCount)
    //     }
    //     setUserCourseSummaryRoster(courseSummaryList)
    // }, [summaryRoster])


    return (<>
        <Typography variant="h2" sx={{ color: "#002A6E", textAlign: "center", mt: 2 }}>
            Roster
        </Typography>

        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        {/* <TableCell>% Done</TableCell>
                        <TableCell>Minutes</TableCell>
                        <TableCell>Days</TableCell> */}
                        <TableCell>First Name</TableCell>
                        <TableCell>Last Name</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {userRoster.map((user, index) => (
                        <TableRow key={index}>
                            {/* <TableCell>{calculateUserDialogPromptIcon(userCourseSummaryRoster[index])}</TableCell>
                            <TableCell>
                                <Tooltip
                                    arrow
                                    title={calculateUserActivityTooltip(userActivitySecRoster[index])}
                                >
                                    <div>
                                        {userActivitySecRoster[index] &&
                                            (userActivitySecRoster[index].course_sec / 60).toFixed(1)}
                                        {" / "}
                                        {userActivitySecRoster[index] &&
                                            (userActivitySecRoster[index].activity_sec / 60).toFixed(1)}
                                    </div>
                                </Tooltip>
                            </TableCell>
                            <TableCell>{userActivitySecRoster[index] && userActivitySecRoster[index].distinct_day_count}</TableCell> */}
                            <TableCell>{user.first_name}</TableCell>
                            <TableCell>{user.last_name}</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>
                                <Button variant="contained" color="error" onClick={() => handleOpenDeleteUserDialog(user)}>
                                    Drop
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>

        <Dialog open={openDeleteUserDialog} onClose={handleCloseDeleteUserDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
                <Typography variant="h4" sx={{ color: "#383838" }}>
                    {"Drop User from Course Offering?"}
                </Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ color: "#8D8D8D" }}>
                    Are you sure you want to this user from this course offering?
                    <br />
                    {deleteUserCourseOffering && deleteUserCourseOffering.email}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "space-between", "& .MuiButton-root": { flex: 1 } }}>
                <Button onClick={handleCloseDeleteUserDialog} sx={{ color: "#787878" }}>
                    Cancel
                </Button>
                <Button onClick={confirmDeleteUser} autoFocus variant="contained" color="error" sx={{ color: "#fff7f7" }}>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>

        <Typography variant="h2" sx={{ color: "#002A6E", textAlign: "center", mt: 2 }}>
            Search and Enroll
        </Typography>

        <form onSubmit={handleSearchSubmit}>
            <Stack direction="row" spacing={2} sx={{ width: '90%', margin: '0 auto', pt: 2 }}>
                <TextField
                    label="First Name"
                    value={searchFirstName}
                    onChange={handleSearchFirstNameChange}
                />
                <TextField
                    label="Last Name"
                    value={searchLastName}
                    onChange={handleSearchLastNameChange}
                />
                <TextField
                    label="Email"
                    value={searchEmail}
                    onChange={handleSearchEmailChange}
                />
                <Button type="submit" variant="contained">
                    Search
                </Button>
            </Stack>
        </form>

        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>First Name</TableCell>
                        <TableCell>Last Name</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {searchUserList.map((user, index) => (
                        <TableRow key={index}>
                            <TableCell>{user.first_name}</TableCell>
                            <TableCell>{user.last_name}</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>
                                <Button type="submit" variant="contained" onClick={() => handleSearchEnroll(user)}>
                                    Enroll
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>

    </>);
};

export default CourseStudentRoster;
